import { TestIdDomain } from 'constants/testIds';

const AlertCDSTestIdsScope = {
  ALERT_CDS: 'alert-cds',
};

export const AlertCDSTestIds = {
  MESSAGE: `${TestIdDomain.SNACKBAR}.message`,
  ACTION_BUTTON: `${AlertCDSTestIdsScope.ALERT_CDS}.action-button`,
};
